/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview PaymentModal SuccessStep step UI.
 * @module modals/PaymentModal/steps/PaymentModalSuccessStep
 */

import { ReactComponent as PaymentSuccessIcon } from "../../../assets/icons/PaymentModal/PaymentSuccessIcon.svg";

const PaymentModalSuccessStep = ({ styles, t, event, getEventCost }) => (
            <div className={styles.stepContent}>
              <div className={styles.cardPaymentTitleContainer}>
                <div className={styles.cardPaymentTitle}>
                  {t("components.paymentModal.cardSection3Title")}
                </div>
                <p className={styles.cardPaymentSubtitle}>
                  {t("components.paymentModal.cardSection3Description")}
                </p>
              </div>
              <div className={styles.cardPaymentSuccessContent}>
                <div className={styles.cardPaymentSuccessIconContainer}>
                  <PaymentSuccessIcon
                    className={styles.cardPaymentSuccessIcon}
                  />
                </div>
                {/* Payment Success Details Section */}
                <div className={styles.cardPaymentSuccessSection}>
                  <div className={styles.cardPaymentSuccessRow}>
                    <span className={styles.cardPaymentSuccessLabel}>
                      {t("components.paymentModal.cardSection3Label1")}
                    </span>
                  </div>
                  <div className={styles.cardPaymentSuccessRowCentered}>
                    <span className={styles.cardPaymentSuccessLabel2}>
                      {t("components.paymentModal.cardSection3Label2")}
                    </span>
                  </div>
                  <div className={styles.cardPaymentSuccessRowCentered}>
                    <span className={styles.cardPaymentSuccessValue}>
                      {event.nombre}
                    </span>
                  </div>
                  <div className={styles.cardPaymentDivider}></div>
                  <div className={styles.cardPaymentSuccessRow}>
                    <span className={styles.cardPaymentSuccessLabel2}>
                      {t("components.paymentModal.cardSection3Label3")}
                    </span>
                    <span className={styles.cardPaymentSuccessValue}>
                      ${getEventCost()} MXN
                    </span>
                  </div>
                </div>
              </div>
            </div>
);

export default PaymentModalSuccessStep;
